import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <CardsSection />
        <CarouselSection />
        <FaqSection />
        <RankingSection />
        <AppSection />
        <UpdatesSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <MediaSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
}